import { render, staticRenderFns } from "./ShippingSetting.vue?vue&type=template&id=774098ef&"
import script from "./ShippingSetting.vue?vue&type=script&lang=js&"
export * from "./ShippingSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports